import React, { useState } from "react";
import {
  Modal,
  Descriptions,
  Image,
  Button,
  Input,
  Select,
  Form,
  message,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Option } = Select;

const BannerDetail = ({ visible, onClose, banner, onDelete, onUpdate }) => {
  const [editing, setEditing] = useState(false);
  const [form] = Form.useForm();
  const [imageBase64, setImageBase64] = useState(null);

  if (!banner) return null;

  const handleEdit = () => {
    setEditing(true);
    form.setFieldsValue({
      banner_link: banner.banner_link,
      banner_location: banner.banner_location,
    });
  };

  const handleCancelEdit = () => {
    setEditing(false);
    setImageBase64(null);
    form.resetFields();
  };

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();
      const updatedData = {
        ...values,
        banner_url:
          imageBase64 === null ? banner.banner_url : imageBase64.split(",")[1], // 변경된 이미지가 있으면 사용
        id: banner.id,
      };
      onUpdate(updatedData); // 부모 컴포넌트로 데이터 전달
      setEditing(false);
      setImageBase64(null);
    } catch (error) {
      console.error(error);
      message.error("수정에 실패했습니다. 입력 값을 확인해주세요.");
    }
  };

  const handleImageChange = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageBase64(e.target.result); // base64 데이터 설정
    };
    reader.readAsDataURL(file);
  };

  return (
    <Modal
      title="배너 상세 정보"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {!editing ? (
        <>
          <Descriptions bordered column={2} size="middle">
            <Descriptions.Item label="작성자">관리자</Descriptions.Item>
            <Descriptions.Item label="생성일자">
              {banner.created_at}
            </Descriptions.Item>
            <Descriptions.Item label="업데이트일자">
              {banner.updated_at}
            </Descriptions.Item>
            <Descriptions.Item label="배너 위치">
              {(function () {
                if (banner.banner_location === "home") {
                  return "홈";
                } else if (banner.banner_location === "group") {
                  return "꼬꼬무리스트";
                } else if (banner.banner_location === "product") {
                  return "제품리스트";
                } else {
                  return "관심정보리스트";
                }
              })()}
            </Descriptions.Item>
            {/* <Form.Item name="banner_position" label="배너 노출 순서">
              {banner.banner_position}
            </Form.Item> */}
            <Descriptions.Item label="배너 링크" span={2}>
              <a
                href={banner.banner_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {banner.banner_link}
              </a>
            </Descriptions.Item>
            <Descriptions.Item label="이미지" span={2}>
              <Image src={banner.banner_url} alt="배너 이미지" width={300} />
            </Descriptions.Item>
          </Descriptions>
          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <Button
              type="primary"
              onClick={handleEdit}
              style={{ marginRight: 8 }}
            >
              수정
            </Button>
            <Button type="danger" onClick={() => onDelete(banner.id)}>
              삭제
            </Button>
            <Button onClick={onClose}>닫기</Button>
          </div>
        </>
      ) : (
        <Form form={form} layout="vertical" initialValues={banner}>
          <Form.Item
            name="banner_link"
            label="배너 링크"
            rules={[{ required: true, message: "배너 링크를 입력해주세요!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="banner_location"
            label="배너 위치"
            rules={[{ required: true, message: "배너 위치를 선택해주세요!" }]}
          >
            <Select>
              <Option value="home">홈</Option>
              <Option value="group">꼬꼬무리스트</Option>
              <Option value="product">제품리스트</Option>
              <Option value="content">관심정보리스트</Option>
            </Select>
          </Form.Item>
          <Form.Item name="banner_position" label="배너 노출 순서">
            <Input type="number" />
          </Form.Item>
          <Form.Item label="이미지 업로드">
            <Upload
              beforeUpload={(file) => {
                handleImageChange(file);
                return false; // 업로드 방지, base64로 처리
              }}
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />}>이미지 선택</Button>
            </Upload>
            {imageBase64 && (
              <Image
                src={imageBase64}
                alt="업로드된 이미지"
                width={300}
                style={{ display: "block", marginTop: "10px" }}
              />
            )}
          </Form.Item>
          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <Button
              type="primary"
              onClick={handleUpdate}
              style={{ marginRight: 8 }}
            >
              저장
            </Button>
            <Button onClick={handleCancelEdit}>취소</Button>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default BannerDetail;
